module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<input type="' +
((__t = ( inputType )) == null ? '' : __t) +
'" name="' +
((__t = ( name )) == null ? '' : __t) +
'" value="' +
((__t = ( value )) == null ? '' : __t) +
'"';
 if (placeholder) { ;
__p += ' placeholder="' +
((__t = ( placeholder )) == null ? '' : __t) +
'"';
 } ;

 if (inputType === 'CHECKBOX' && value == true) { ;
__p += ' checked';
 } ;
__p += ' />';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/ejs-loader!./~/icarus-forms/module/js/templates/controls/input.ejs
// module id = 205
// module chunks = 2 3